import React from 'react';
import { Col, Row } from '@perxis-auto/ui-kit/lib/components/Grid';
import { Header as UIHeader } from '@perxis-auto/ui-kit/lib/components/Header';
import Skeleton from 'antd/es/skeleton';

import { CarHeaderSkeletonProps } from './CarHeader.types';

import styles from './CarHeader.module.scss';

function CarHeaderSkeleton({ showTitle, active = true }: CarHeaderSkeletonProps) {
  return (
    <UIHeader className={`${styles.carHeader} ${styles.skeleton}`}>
      <Row align="middle" gutter={[0, 'vertical-sky']}>
        <Col
          xs={{ span: 12, order: 1 }}
          sm={{ span: 12, order: 1 }}
          md={{ span: 6, order: 1 }}
        >
          <Skeleton.Input
            block
            active={active}
            size="small"
            className={styles.skeletonBack}
          />
        </Col>
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 12, order: 2 }}
        >
          <Row gutter={[0, 10]}>
            <Col span={24}>
              <Row justify="center">
                <Col flex="0 0 auto">
                  {!!showTitle && (
                    <Skeleton.Input
                      block
                      active={active}
                      className={styles.skeletonTitle}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col flex="0 0 auto">
                  {!!showTitle && (
                    <Skeleton.Input
                      block
                      active={active}
                      className={styles.skeletonDescription}
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col
          xs={{ span: 12, order: 2 }}
          sm={{ span: 12, order: 2 }}
          md={{ span: 6, order: 3 }}
        >
          <Row justify="end">
            <Col flex="0 0 auto">
              <Skeleton.Input
                block
                active={active}
                size="small"
                className={styles.skeletonMarkers}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </UIHeader>
  );
}

export default CarHeaderSkeleton;
